import cloneDeep from 'lodash/cloneDeep';

const TEST_CONNECTION_CONFIG_KEYS = ['testConnectionAt', 'testConnectionFailedStatus'];
const emptyGroupManagement = {
  entryHash: {},
  associationHash: {
    year: {},
    class: {},
    custom: {},
    subject: {}
  }
};

/**
 * Builds the studentManagement object shape expected by v1 putClients / postClients.
 */
const buildLegacyStudentManagement = (
  config = {},
  groupManagement = null,
  showGroupSection = false,
  studentSelectionInRiskAssessmentEnabled = false,
  includeTestConnectionFields = false
) => {
  const vendorConfig = cloneDeep(config);

  let testConnectionAt = '';
  let testConnectionFailedStatus = '';
  if (includeTestConnectionFields) {
    testConnectionAt = vendorConfig.testConnectionAt || '';
    testConnectionFailedStatus = vendorConfig.testConnectionFailedStatus || '';
    TEST_CONNECTION_CONFIG_KEYS.forEach((key) => {
      delete vendorConfig[key];
    });
  }

  if (vendorConfig.apiAuthList) {
    vendorConfig.apiAuthList = JSON.stringify(vendorConfig.apiAuthList);
  }

  if (vendorConfig.clientToStbMedicalConditionMap) {
    vendorConfig.clientToStbMedicalConditionMap = JSON.stringify(
      vendorConfig.clientToStbMedicalConditionMap
    );
  }

  const clientApiMetadata = {
    ...vendorConfig,
    groupManagement: groupManagement || emptyGroupManagement
  };

  if (showGroupSection) {
    clientApiMetadata.studentSelectionInRiskAssessmentEnabled =
      studentSelectionInRiskAssessmentEnabled;
  }

  const studentManagement = { clientApiMetadata };

  if (includeTestConnectionFields) {
    studentManagement.testConnectionAt = testConnectionAt;
    studentManagement.testConnectionFailedStatus = testConnectionFailedStatus;
  }

  return studentManagement;
};

export { emptyGroupManagement, TEST_CONNECTION_CONFIG_KEYS };
export default buildLegacyStudentManagement;
